/**
 * Categories an Employer Certificate is made for: DSA (175 Rs) and PCO
 * (167 Rs). Mirrors EMPLOYER_CERTIFICATE_CATEGORIES in the API, which the
 * Employer Certificate list and get-application-by-id filter on.
 */
export const EMPLOYER_CERTIFICATE_CATEGORIES = ["CAT_DSA", "CAT_PCO"];

export const isEmployerCertificateCategory = (category?: string | null) =>
  !!category && EMPLOYER_CERTIFICATE_CATEGORIES.includes(category);
